<template>
  <span>
    <v-row dense class="mt-2">
      <v-col cols="12" md="6" class="d-flex flex-column">
        <dashboard-isfp-psfp-kpis-simulador
          :kpis="kpisExibidos"
          :loading="loadingSimulacaoUi"
          :parcela-b-loading="parcelaBLoading"
          :parcela-b-disabled="parcelaBDisabled"
          @abrir-parcela-b="$emit('abrir-parcela-b')"
        />

        <dashboard-isfp-psfp-tabela-simulador
          class="tabela-simulador-altura flex-grow-1"
          :tabelaServicos="tabelaServicos"
          :selectedCodigos="servicosSelecionados"
          :loading="loadingBase"
          @toggleServico="toggleServico"
        />
      </v-col>

      <v-col cols="12" md="6"  class="d-flex flex-column" >
        <dashboard-isfp-psfp-top10-psfp-simulador
          class="flex-grow-1"
          :topPsfp="topSimuladoExibido"
          :loading="loadingSimulacaoUi"
          :selected-count="servicosSelecionados.length"
          @limpar-selecao="limparSelecao"
          @remover-servico="removerServico"
          @simular="simular"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import DashboardIsfpPsfpService from "@/services/DashboardIsfpPsfpService";

export default {
  name: "DashboardIsfpPsfpSimulador",
  components: {
    DashboardIsfpPsfpKpisSimulador: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpKpisSimulador.vue"
      ),
    DashboardIsfpPsfpTabelaSimulador: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpTabelaSimulador.vue"
      ),
    DashboardIsfpPsfpTop10PsfpSimulador: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpTop10PsfpSimulador.vue"
      ),
  },
  props: {
    competencia: { type: String, required: true },
    modoPeriodo: { type: String, default: "ano_civil" },
    ano: { type: Number, default: null },
    activatedTab: { type: Number, required: true },
    reloadKey: { type: Number, default: 0 },
    parcelaBLoading: { type: Boolean, default: false },
    parcelaBDisabled: { type: Boolean, default: false },
  },
  data: () => ({
    tabelaServicos: [],
    servicosSelecionados: [],
    resultadoSimulado: null,
    loadingBase: false,
    loadingSimulacao: false,
    simulacaoTimeout: null,
    simulacaoRequestSeq: 0,
  }),
  computed: {
    loadingSimulacaoUi() {
      return this.loadingBase || this.loadingSimulacao;
    },

    kpisExibidos() {
      return this.resultadoSimulado?.kpis ?? {};
    },

    topSimuladoExibido() {
      if (this.resultadoSimulado?.top_psfp?.length) {
        return this.resultadoSimulado.top_psfp;
      }
      return this.tabelaServicos.filter((item) =>
        this.servicosSelecionados.includes(item?.indice_categoria),
      );
    },

    servicosSelecionadosDetalhes() {
      if (this.resultadoSimulado?.top_psfp?.length) {
        return this.resultadoSimulado.top_psfp;
      }
      return this.tabelaServicos.filter((item) =>
        this.servicosSelecionados.includes(item?.indice_categoria),
      );
    },
  },
  mounted() {
    this.carregarBase();
  },
  methods: {
    async carregarBase() {
      if (this.activatedTab !== 4) return;
      this.loadingBase = true;
      this.$emit("updateLoadingDados", true);
      try {
        const res = await DashboardIsfpPsfpService.getDadosTela4Simulador(
          this.competencia,
          this.modoPeriodo,
          this.ano,
          [],
        );
        this.tabelaServicos = res?.tabela_servicos || [];
        this.resultadoSimulado = null;
      } catch {
        this.$toast.error("Erro ao carregar dados do simulador.", "", {
          position: "topRight",
        });
        this.tabelaServicos = [];
      } finally {
        this.loadingBase = false;
        this.$emit("updateLoadingDados", false);
      }
    },

    toggleServico(item) {
      const indice = item?.indice_categoria;
      if (!indice) return;

      const jaSelecionado = this.servicosSelecionados.includes(indice);

      if (jaSelecionado) {
        this.servicosSelecionados = this.servicosSelecionados.filter(
          (i) => i !== indice,
        );
        this.resultadoSimulado = null;
        return;
      }

      if (this.servicosSelecionados.length >= 10) {
        this.$toast.info("Você pode selecionar no máximo 10 serviços.", "", {
          position: "topRight",
        });
        return;
      }

      this.servicosSelecionados = [...this.servicosSelecionados, indice];
      this.resultadoSimulado = null;
    },

    removerServico(indice) {
      this.servicosSelecionados = this.servicosSelecionados.filter(
        (i) => i !== indice,
      );
      this.resultadoSimulado = null;
    },

    limparSelecao() {
      this.servicosSelecionados = [];
      this.resultadoSimulado = null;
    },

    async simular() {
      if (this.servicosSelecionados.length < 2) return;

      const seq = ++this.simulacaoRequestSeq;
      this.loadingSimulacao = true;

      try {
        const res = await DashboardIsfpPsfpService.getDadosTela4Simulador(
          this.competencia,
          this.modoPeriodo,
          this.ano,
          this.servicosSelecionados,
        );
        if (seq !== this.simulacaoRequestSeq) return;
        this.resultadoSimulado = res || null;
      } catch {
        if (seq !== this.simulacaoRequestSeq) return;
        this.$toast.error("Erro ao simular dados.", "", {
          position: "topRight",
        });
        this.resultadoSimulado = null;
      } finally {
        if (seq === this.simulacaoRequestSeq) {
          this.loadingSimulacao = false;
        }
      }
    },

    corFaixa(faixaChave) {
      const cores = {
        ate_1: "#4CAF50",
        de_1_a_5: "#8BC34A",
        de_5_a_10: "#FFC107",
        de_10_a_20: "#FF9800",
        acima_20: "#F44336",
      };
      return cores[faixaChave] ?? "#000";
    },

    formatarContribuicao(valor) {
      if (valor === null || valor === undefined || isNaN(valor)) return "—";
      return `${Number(valor).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} p.p.`;
    },
  },
  watch: {
      servicosSelecionados(val) { 
    if (val.length < 2) {
      this.resultadoSimulado = null;
      return;
    }
    clearTimeout(this.simulacaoTimeout);
    this.simulacaoTimeout = setTimeout(() => {
      this.simular();
    }, 400);
  },
    activatedTab() {
      this.carregarBase();
    },
    competencia() {
      this.limparSelecao();
      this.carregarBase();
    },
    modoPeriodo() {
      this.limparSelecao();
      this.carregarBase();
    },
    ano() {
      this.limparSelecao();
      this.carregarBase();
    },
    reloadKey() {
      this.limparSelecao();
      this.carregarBase();
    },
  },
};
</script>

<style scoped>
.tabela-simulador-altura {
    min-height: 500px; 
}

.tabela-simulador-altura ::v-deep .v-card {
  height: 100%;
}

.tabela-simulador-altura ::v-deep .v-card__text {
  height: calc(100% - 64px);
  overflow: auto;
}
</style>